export default {
  applicationId: ''
};
